import { ErrorData } from '@/types';
import { message } from 'antd';
import i18next from 'i18next';

const NO_CARRIER_MATCHES_ERROR_CODE = 889000;
const NO_MATCHING_CARRIER_ERROR_CODE = 760001;
const SLOT_SELECTION_REQUIRED_CODE = 'SLOT_SELECTION_REQUIRED';

export const handleErrorMessage = (
  error?: ErrorData,
  defaultErrorMessage?: string,
  isMutation?: boolean,
) => {
  // Suppress UI error display for carrier-related error codes
  if (
    error?.code === NO_CARRIER_MATCHES_ERROR_CODE ||
    error?.code === NO_MATCHING_CARRIER_ERROR_CODE
  ) {
    return;
  }

  // Suppress UI error display for the pickup slot-selection gate — the
  // caller handles this inline (e.g. opening the slot picker) instead of
  // showing a toast.
  if (error?.code === SLOT_SELECTION_REQUIRED_CODE) {
    return;
  }

  const generalErrorMessage =
    error?.message ||
    defaultErrorMessage ||
    i18next.t(isMutation ? 'operation_failed' : 'unexpected_error');
  // Validation errors (422)
  if (error?.statusCode === 422 && error.object) {
    let hasArrayError = false;

    for (const key in error.object) {
      if (Array.isArray(error.object[key])) {
        message.error(error.object[key]);
        hasArrayError = true;
      }
    }

    if (!hasArrayError) {
      message.error(generalErrorMessage);
    }

    return;
  }

  message.error(generalErrorMessage);
};
